export enum StatusBadgeVariantEnum {
  success = 'SUCCESS',
  neutral = 'NEUTRAL',
  warning = 'WARNING',
  danger = 'DANGER',
}

export type Props = {
  label: string;
  variant: StatusBadgeVariantEnum;
  compact?: boolean;
};
